import ExtendableError from '@mmw/error';

export class InvalidTokenError extends ExtendableError {}
